import { Login as DLLogin } from './../DL/Login'

import { ValidateSqlInjection } from './Security'


const Login = async (username, password) => {
    try {
        if (!username || username.toString().trim() === '') {
            return { success: false, message: 'Escribe tu usuario' }
        }

        if (!password || password.toString().trim() === '') {
            return { success: false, message: 'Escribe tu contraseña' }
        }

        const isUsernameWrong = await ValidateSqlInjection(username)
        if (isUsernameWrong) {
            return { success: false, message: 'El usuario que escribiste no es válido' }
        }

        const isPasswordWrong = await ValidateSqlInjection(password)
        if (isPasswordWrong) {
            return { success: false, message: 'La contraseña que escribiste no es válida' }
        }

        const response = await DLLogin(username.trim(), password)

        if (response.success && response.data) {
            const token = response.data.token;
            const refreshToken = response.data.refreshToken;
            const user = response.data.user;
            const role = user?.role || response.data.role;

            try {
                if (token) {
                    localStorage.setItem('token', token);
                }
                if (refreshToken) {
                    localStorage.setItem('refreshToken', refreshToken);
                }
                if (role) {
                    localStorage.setItem('role', role);
                }
                if (user) {
                    localStorage.setItem('user', JSON.stringify(user));
                }
            } catch (storageError) {
                console.warn('No fue posible guardar la sesión en localStorage:', storageError);
            }

            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message || 'Usuario y/o contraseña incorrecta' }
        }
    } catch (error) {
        return { success: false, message: 'Ha habido un error al intentar iniciar sesión. Inténtalo nuevamente o inténtalo más tarde' }
    }
}

export { Login };